import {
  SHOW_LESS,
  SHOW_MORE,
} from 'components/PDP/Upsells/components/Upsell/ShowMore/translations/constants';

export const showMoreCommonLocale = {
  [SHOW_MORE]: 'Show More',
  [SHOW_LESS]: 'Show Less',
};
